var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUntitled1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "400px",
    height: "400px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M -0.5,-0.5 C 132.833,-0.5 266.167,-0.5 399.5,-0.5C 399.5,132.833 399.5,266.167 399.5,399.5C 266.167,399.5 132.833,399.5 -0.5,399.5C -0.5,266.167 -0.5,132.833 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f03131",
    d: "M 190.5,260.5 C 190.833,261.5 191.5,262.167 192.5,262.5C 192.5,263.167 192.833,263.5 193.5,263.5C 195.146,265.812 197.146,267.812 199.5,269.5C 201.521,268.145 203.188,266.479 204.5,264.5C 205.5,264.167 206.167,263.5 206.5,262.5C 207.167,262.5 207.5,262.167 207.5,261.5C 208.833,260.833 209.833,259.833 210.5,258.5C 219.891,252.406 220.724,245.406 213,237.5C 212.333,236.167 212.333,234.833 213,233.5C 249.833,196.667 286.667,159.833 323.5,123C 324.609,122.362 325.775,121.862 327,121.5C 340.519,126.521 350.353,135.521 356.5,148.5C 356.167,149.5 355.5,150.167 354.5,150.5C 348.136,139.136 339.136,130.47 327.5,124.5C 289.555,160.778 252.222,197.778 215.5,235.5C 217.864,238.699 220.03,242.032 222,245.5C 227.5,248.333 231.667,252.5 234.5,258C 237.368,258.861 239.702,260.528 241.5,263C 242.833,263.667 244.167,263.667 245.5,263C 270.701,237.632 296.035,212.465 321.5,187.5C 321.167,188.833 320.833,190.167 320.5,191.5C 295.702,216.799 270.702,241.965 245.5,267C 241.211,266.429 237.544,264.429 234.5,261C 231.983,260.743 229.65,261.41 227.5,263C 222,268.5 216.5,274 211,279.5C 210.333,280.167 210.333,280.833 211,281.5C 220.105,291.611 230.105,300.611 241,308.5C 242.653,315.247 240.153,320.081 233.5,323C 232.5,323.667 231.5,323.667 230.5,323C 223.92,315.417 216.92,308.083 209.5,301C 209.167,300.833 208.833,300.667 208.5,300.5C 207.548,302.045 207.215,303.712 207.5,305.5C 203.833,306.833 200.167,306.833 196.5,305.5C 195.5,305.5 194.5,305.5 193.5,305.5C 193.005,300.259 195.171,298.925 200,301.5C 202.891,301.74 205.391,300.907 207.5,299C 206.627,297.955 205.627,297.122 204.5,296.5C 203.188,294.521 201.521,292.855 199.5,291.5C 197.146,293.188 195.146,295.188 193.5,297.5C 192.833,297.5 192.5,297.833 192.5,298.5C 184.3,305.533 176.966,313.366 170.5,322C 169.391,322.638 168.225,323.138 167,323.5C 152.861,316.081 153.028,308.914 167.5,302C 174.333,295.167 181.167,288.333 188,281.5C 188.667,280.833 188.667,280.167 188,279.5C 181.764,272.593 174.931,266.427 167.5,261C 164.127,261.642 161.127,263.309 158.5,266C 156.835,266.788 155.169,267.122 153.5,267C 116.333,229.833 79.1667,192.667 42,155.5C 40.9858,150.187 42.3191,145.52 46,141.5C 51.688,133.579 58.8547,127.412 67.5,123C 70.2113,121.195 72.8779,121.195 75.5,123C 112.333,159.833 149.167,196.667 186,233.5C 186.667,234.833 186.667,236.167 186,237.5C 183.509,240.319 181.676,243.486 180.5,247C 182.099,252.769 185.433,257.269 190.5,260.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010000",
    d: "M 70.5,124.5 C 71.9217,124.709 73.255,125.209 74.5,126C 110.694,162.194 146.86,198.36 183,234.5C 183.315,235.908 182.982,237.241 182,238.5C 179.597,240.305 177.93,242.638 177,245.5C 171.667,248.167 167.667,252.167 165,257.5C 161.961,258.531 159.461,260.365 157.5,263C 156.167,263.667 154.833,263.667 153.5,263C 117.333,226.833 81.1667,190.667 45,154.5C 44.585,149.979 45.9184,145.979 49,142.5C 55.1878,135.13 62.3545,129.13 70.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010000",
    d: "M 354.5,150.5 C 354.657,151.873 354.49,153.207 354,154.5C 342.965,165.368 332.131,176.368 321.5,187.5C 296.035,212.465 270.701,237.632 245.5,263C 244.167,263.667 242.833,263.667 241.5,263C 239.702,260.528 237.368,258.861 234.5,258C 231.667,252.5 227.5,248.333 222,245.5C 220.03,242.032 217.864,238.699 215.5,235.5C 252.222,197.778 289.555,160.778 327.5,124.5C 339.136,130.47 348.136,139.136 354.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#490f10",
    d: "M 161.5,132.5 C 180.833,131.167 200.167,131.167 219.5,132.5C 217.396,132.201 215.396,132.534 213.5,133.5C 215.743,134.474 218.076,134.808 220.5,134.5C 217.167,135.833 213.833,135.833 210.5,134.5C 211.376,134.631 212.043,134.298 212.5,133.5C 210.5,133.167 208.5,132.833 206.5,132.5C 204.048,132.539 202.048,133.206 200.5,134.5C 200.167,134.5 199.833,134.5 199.5,134.5C 194.944,132.558 189.944,131.892 184.5,132.5C 176.833,132.5 169.167,132.5 161.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b02423",
    d: "M 184.5,132.5 C 189.944,131.892 194.944,132.558 199.5,134.5C 198.5,134.5 197.5,134.5 196.5,134.5C 195.167,134.5 193.833,134.5 192.5,134.5C 192.629,136.216 192.962,137.883 193.5,139.5C 190.736,136.721 187.736,134.388 184.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a82222",
    d: "M 219.5,132.5 C 227.5,132.5 235.5,132.5 243.5,132.5C 242.459,135.458 242.459,138.458 243.5,141.5C 244.11,142.391 244.443,143.391 244.5,144.5C 243.833,150.833 243.167,157.167 242.5,163.5C 242.813,159.958 242.479,156.625 241.5,153.5C 241.26,150.421 241.593,147.421 242.5,144.5C 241.846,142.885 241.346,141.218 241,139.5C 240.691,140.766 240.191,141.933 239.5,143C 230.814,143.832 222.147,143.665 213.5,142.5C 215.396,141.534 217.396,141.201 219.5,141.5C 225.842,141.666 232.175,141.5 238.5,141C 239.337,139.989 239.67,138.822 239.5,137.5C 240.404,136.791 240.737,135.791 240.5,134.5C 238.5,134.5 236.5,134.5 234.5,134.5C 229.833,134.5 225.167,134.5 220.5,134.5C 218.076,134.808 215.743,134.474 213.5,133.5C 215.396,132.534 217.396,132.201 219.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a42121",
    d: "M 210.5,134.5 C 207.167,134.5 203.833,134.5 200.5,134.5C 202.048,133.206 204.048,132.539 206.5,132.5C 208.5,132.833 210.5,133.167 212.5,133.5C 212.043,134.298 211.376,134.631 210.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e52e2e",
    d: "M 161.5,132.5 C 169.167,132.5 176.833,132.5 184.5,132.5C 187.736,134.388 190.736,136.721 193.5,139.5C 194.391,140.11 195.391,140.443 196.5,140.5C 196.833,140.5 197.167,140.5 197.5,140.5C 197.5,140.833 197.5,141.167 197.5,141.5C 197.158,142.338 196.492,142.672 195.5,142.5C 194.5,143.833 193.5,143.833 192.5,142.5C 186.463,142.171 180.463,142.504 174.5,143.5C 175.991,144.244 177.491,144.91 179,145.5C 184.015,145.245 189.515,145.245 195.5,145.5C 197.167,145.5 198.833,145.5 200.5,145.5C 202.5,145.5 204.5,145.5 206.5,145.5C 211.833,145.5 217.167,145.5 222.5,145.5C 227.975,146.489 233.642,146.822 239.5,146.5C 239.333,157.172 239.5,167.839 240,178.5C 241.163,171.547 241.663,164.547 241.5,157.5C 241.5,156.167 241.5,154.833 241.5,153.5C 242.479,156.625 242.813,159.958 242.5,163.5C 242.5,168.5 242.5,173.5 242.5,178.5C 241.186,183.348 241.186,188.348 242.5,193.5C 243.107,193.376 243.44,193.043 243.5,192.5C 246.516,189.982 249.35,187.316 252,184.5C 252.667,171.833 252.667,159.167 252,146.5C 250.333,145.833 248.667,145.167 247,144.5C 246.601,144.728 246.435,145.062 246.5,145.5C 245.596,144.791 245.263,143.791 245.5,142.5C 248.167,142.5 250.833,142.5 253.5,142.5C 254.166,149.492 254.5,156.659 254.5,164C 254.636,171.932 254.136,179.766 253,187.5C 249.595,190.784 246.095,193.95 242.5,197C 231.833,197.333 221.167,197.667 210.5,198C 209.663,199.011 209.33,200.178 209.5,201.5C 209.721,202.735 210.388,203.735 211.5,204.5C 209.955,205.452 208.288,205.785 206.5,205.5C 206.167,205.5 205.833,205.5 205.5,205.5C 200.167,205.5 194.833,205.5 189.5,205.5C 189.5,202.833 189.5,200.167 189.5,197.5C 179.828,197.666 170.161,197.5 160.5,197C 156.667,193.833 152.833,190.667 149,187.5C 148.333,172.5 148.333,157.5 149,142.5C 152.167,139.333 155.333,136.167 158.5,133C 159.448,132.517 160.448,132.351 161.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#541112",
    d: "M 234.5,134.5 C 236.5,134.5 238.5,134.5 240.5,134.5C 240.737,135.791 240.404,136.791 239.5,137.5C 238.198,135.972 236.531,134.972 234.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f0f0e",
    d: "M 196.5,134.5 C 195.167,136.5 195.167,138.5 196.5,140.5C 195.391,140.443 194.391,140.11 193.5,139.5C 192.962,137.883 192.629,136.216 192.5,134.5C 193.833,134.5 195.167,134.5 196.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#100302",
    d: "M 196.5,134.5 C 197.5,134.5 198.5,134.5 199.5,134.5C 199.833,134.5 200.167,134.5 200.5,134.5C 203.833,134.5 207.167,134.5 210.5,134.5C 213.833,135.833 217.167,135.833 220.5,134.5C 225.167,134.5 229.833,134.5 234.5,134.5C 236.531,134.972 238.198,135.972 239.5,137.5C 239.67,138.822 239.337,139.989 238.5,141C 232.175,141.5 225.842,141.666 219.5,141.5C 212.352,140.508 205.019,140.175 197.5,140.5C 197.167,140.5 196.833,140.5 196.5,140.5C 195.167,138.5 195.167,136.5 196.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 56.5,136.5 C 57.2389,136.369 57.9056,136.536 58.5,137C 53.8957,141.603 50.0624,146.77 47,152.5C 46.4795,150.711 46.8129,149.044 48,147.5C 51.0486,143.957 53.8819,140.291 56.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ed3030",
    d: "M 340.5,137.5 C 340.897,136.475 341.563,136.308 342.5,137C 346.05,140.883 349.217,145.049 352,149.5C 352.667,150.5 352.667,151.5 352,152.5C 349.069,146.745 345.236,141.745 340.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#470f0f",
    d: "M 253.5,142.5 C 250.833,142.5 248.167,142.5 245.5,142.5C 245.263,143.791 245.596,144.791 246.5,145.5C 245.377,146.757 244.711,146.424 244.5,144.5C 244.443,143.391 244.11,142.391 243.5,141.5C 245.288,141.785 246.955,141.452 248.5,140.5C 246.711,139.377 246.378,138.044 247.5,136.5C 249.515,138.576 251.515,140.576 253.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#841b1b",
    d: "M 192.5,142.5 C 192.389,143.117 192.056,143.617 191.5,144C 193.058,144.21 194.391,144.71 195.5,145.5C 189.515,145.245 184.015,145.245 179,145.5C 177.491,144.91 175.991,144.244 174.5,143.5C 180.463,142.504 186.463,142.171 192.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#46100f",
    d: "M 192.5,142.5 C 193.5,143.833 194.5,143.833 195.5,142.5C 197.292,143.309 199.292,143.809 201.5,144C 200.944,144.383 200.611,144.883 200.5,145.5C 198.833,145.5 197.167,145.5 195.5,145.5C 194.391,144.71 193.058,144.21 191.5,144C 192.056,143.617 192.389,143.117 192.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 82.5,144.5 C 85.2971,146.795 87.9638,149.295 90.5,152C 86.7981,150.804 84.1314,148.304 82.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#851b1b",
    d: "M 197.5,141.5 C 199.604,141.201 201.604,141.534 203.5,142.5C 203.291,143.086 202.957,143.586 202.5,144C 204.058,144.21 205.391,144.71 206.5,145.5C 204.5,145.5 202.5,145.5 200.5,145.5C 200.611,144.883 200.944,144.383 201.5,144C 199.292,143.809 197.292,143.309 195.5,142.5C 196.492,142.672 197.158,142.338 197.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#240a07",
    d: "M 241.5,153.5 C 241.5,154.833 241.5,156.167 241.5,157.5C 240.517,153.702 240.183,149.702 240.5,145.5C 234.5,145.5 228.5,145.5 222.5,145.5C 217.167,145.5 211.833,145.5 206.5,145.5C 205.391,144.71 204.058,144.21 202.5,144C 202.957,143.586 203.291,143.086 203.5,142.5C 201.604,141.534 199.604,141.201 197.5,141.5C 197.5,141.167 197.5,140.833 197.5,140.5C 205.019,140.175 212.352,140.508 219.5,141.5C 217.396,141.201 215.396,141.534 213.5,142.5C 222.147,143.665 230.814,143.832 239.5,143C 240.191,141.933 240.691,140.766 241,139.5C 241.346,141.218 241.846,142.885 242.5,144.5C 241.593,147.421 241.26,150.421 241.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#af2323",
    d: "M 204.5,141.5 C 207.247,141.187 209.914,141.52 212.5,142.5C 209.868,143.257 207.368,143.59 205,143.5C 204.536,142.906 204.369,142.239 204.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43232",
    d: "M 315.5,144.5 C 316.525,144.897 316.692,145.563 316,146.5C 313.936,149.274 311.436,151.107 308.5,152C 311.039,149.63 313.372,147.13 315.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#470f0f",
    d: "M 222.5,145.5 C 228.5,145.5 234.5,145.5 240.5,145.5C 240.183,149.702 240.517,153.702 241.5,157.5C 241.663,164.547 241.163,171.547 240,178.5C 239.5,167.839 239.333,157.172 239.5,146.5C 233.642,146.822 227.975,146.489 222.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#120402",
    d: "M 244.5,144.5 C 244.711,146.424 245.377,146.757 246.5,145.5C 246.435,145.062 246.601,144.728 247,144.5C 248.667,145.167 250.333,145.833 252,146.5C 252.667,159.167 252.667,171.833 252,184.5C 249.35,187.316 246.516,189.982 243.5,192.5C 242.514,188.03 242.181,183.363 242.5,178.5C 242.5,173.5 242.5,168.5 242.5,163.5C 243.167,157.167 243.833,150.833 244.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 67.5,149.5 C 67.8966,148.475 68.5632,148.308 69.5,149C 99.6667,177.833 129.167,207.333 158,237.5C 158.667,238.167 158.667,238.833 158,239.5C 127.161,210.134 96.9943,180.134 67.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#761818",
    d: "M 195.5,149.5 C 195.833,150.167 196.167,150.833 196.5,151.5C 193.607,150.409 191.107,150.409 189,151.5C 188.437,150.275 188.77,149.275 190,148.5C 191.762,149.074 193.595,149.407 195.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#491211",
    d: "M 195.5,149.5 C 209.677,149.171 223.677,149.504 237.5,150.5C 228.161,150.334 218.827,150.5 209.5,151C 210.737,151.232 211.737,151.732 212.5,152.5C 207.146,152.431 201.813,152.098 196.5,151.5C 196.167,150.833 195.833,150.167 195.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#110302",
    d: "M 237.5,150.5 C 237.5,151.833 237.5,153.167 237.5,154.5C 236.5,154.5 235.5,154.5 234.5,154.5C 227.361,153.293 220.028,152.626 212.5,152.5C 211.737,151.732 210.737,151.232 209.5,151C 218.827,150.5 228.161,150.334 237.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d32b2b",
    d: "M 356.5,148.5 C 357.629,150.628 357.796,152.961 357,155.5C 344.965,167.702 332.798,179.702 320.5,191.5C 320.833,190.167 321.167,188.833 321.5,187.5C 332.131,176.368 342.965,165.368 354,154.5C 354.49,153.207 354.657,151.873 354.5,150.5C 355.5,150.167 356.167,149.5 356.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#791919",
    d: "M 212.5,152.5 C 220.028,152.626 227.361,153.293 234.5,154.5C 226.937,154.772 219.603,154.105 212.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c1616",
    d: "M 237.5,157.5 C 227.979,157.707 218.479,157.374 209,156.5C 207.5,156.667 206,156.833 204.5,157C 205.737,157.232 206.737,157.732 207.5,158.5C 204.391,158.345 201.391,157.678 198.5,156.5C 198.667,156.167 198.833,155.833 199,155.5C 211.519,155.707 224.353,156.373 237.5,157.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#260d08",
    d: "M 237.5,157.5 C 237.5,158.5 237.5,159.5 237.5,160.5C 227.393,160.577 217.393,159.91 207.5,158.5C 206.737,157.732 205.737,157.232 204.5,157C 206,156.833 207.5,156.667 209,156.5C 218.479,157.374 227.979,157.707 237.5,157.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 63.5,160.5 C 63.8966,159.475 64.5632,159.308 65.5,160C 71.6667,166.167 77.8333,172.333 84,178.5C 84.6667,179.167 84.6667,179.833 84,180.5C 77.2982,173.631 70.4649,166.964 63.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9e2020",
    d: "M 163.5,179.5 C 162.833,174.5 162.167,169.5 161.5,164.5C 161.337,162.143 161.503,159.81 162,157.5C 162.333,158.167 162.667,158.833 163,159.5C 163.5,166.158 163.666,172.825 163.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#761818",
    d: "M 237.5,163.5 C 230.159,163.334 222.826,163.5 215.5,164C 219.688,164.176 223.688,164.676 227.5,165.5C 222.156,165.666 216.823,165.499 211.5,165C 210.062,164.781 208.729,164.281 207.5,163.5C 217.659,162.177 227.659,162.177 237.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43232",
    d: "M 329.5,148.5 C 330.239,148.369 330.906,148.536 331.5,149C 302,179.833 271.833,210 241,239.5C 240.333,238.833 240.333,238.167 241,237.5C 270.034,207.3 299.534,177.633 329.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#260907",
    d: "M 237.5,163.5 C 234.663,165.402 231.329,166.069 227.5,165.5C 223.688,164.676 219.688,164.176 215.5,164C 222.826,163.5 230.159,163.334 237.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ee3030",
    d: "M 333.5,159.5 C 334.239,159.369 334.906,159.536 335.5,160C 328.667,166.833 321.833,173.667 315,180.5C 314.333,179.833 314.333,179.167 315,178.5C 321.369,172.298 327.536,165.965 333.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#481010",
    d: "M 234.5,168.5 C 235.978,168.238 237.311,168.571 238.5,169.5C 238.376,170.107 238.043,170.44 237.5,170.5C 234.428,170.817 231.428,170.484 228.5,169.5C 230.396,168.534 232.396,168.201 234.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 81.5,171.5 C 81.8966,170.475 82.5632,170.308 83.5,171C 87.3333,174.833 91.1667,178.667 95,182.5C 95.6667,183.167 95.6667,183.833 95,184.5C 90.6312,179.963 86.1312,175.63 81.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 102.5,171.5 C 102.897,170.475 103.563,170.308 104.5,171C 109.333,175.833 114.167,180.667 119,185.5C 119.667,186.167 119.667,186.833 119,187.5C 113.631,181.964 108.131,176.63 102.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9c2020",
    d: "M 234.5,168.5 C 232.396,168.201 230.396,168.534 228.5,169.5C 231.428,170.484 234.428,170.817 237.5,170.5C 230.207,171.542 222.873,171.042 215.5,169C 216,168.5 216.5,168 217,167.5C 222.811,167.237 228.644,167.571 234.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 294.5,170.5 C 295.239,170.369 295.906,170.536 296.5,171C 291,176.5 285.5,182 280,187.5C 279.333,186.833 279.333,186.167 280,185.5C 285.037,180.631 289.87,175.631 294.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 69.5,173.5 C 98.16,201.993 126.993,230.327 156,258.5C 157.337,257.235 158.837,256.735 160.5,257C 158.938,259.115 156.938,260.115 154.5,260C 125.581,231.583 97.2479,202.749 69.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f33131",
    d: "M 315.5,170.5 C 316.239,170.369 316.906,170.536 317.5,171C 313,175.5 308.5,180 304,184.5C 303.333,183.833 303.333,183.167 304,182.5C 308.037,178.631 311.87,174.631 315.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d0f0d",
    d: "M 161.5,164.5 C 162.167,169.5 162.833,174.5 163.5,179.5C 163.232,181.099 163.566,182.432 164.5,183.5C 166.924,183.192 169.257,183.526 171.5,184.5C 169.604,185.466 167.604,185.799 165.5,185.5C 164.5,185.5 163.5,185.5 162.5,185.5C 161.978,192.136 161.145,192.136 160,185.5C 158.927,186.28 157.76,186.113 156.5,185C 157.891,183.98 159.391,183.147 161,182.5C 161.499,176.509 161.666,170.509 161.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a82222",
    d: "M 164.5,183.5 C 167.833,182.167 171.167,182.167 174.5,183.5C 173.624,183.369 172.957,183.702 172.5,184.5C 174.5,184.833 176.5,185.167 178.5,185.5C 180.952,185.461 182.952,184.794 184.5,183.5C 184.833,183.5 185.167,183.5 185.5,183.5C 186.694,184.777 188.36,185.444 190.5,185.5C 192.64,185.444 194.306,184.777 195.5,183.5C 199.481,183.972 202.981,183.972 206,183.5C 206.167,183.833 206.333,184.167 206.5,184.5C 204.659,185.23 202.825,185.897 201,186.5C 189.198,186.8 177.365,186.467 165.5,185.5C 167.604,185.799 169.604,185.466 171.5,184.5C 169.257,183.526 166.924,183.192 164.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#531112",
    d: "M 174.5,183.5 C 177.993,183.998 181.326,183.998 184.5,183.5C 182.952,184.794 180.952,185.461 178.5,185.5C 176.5,185.167 174.5,184.833 172.5,184.5C 172.957,183.702 173.624,183.369 174.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f1314",
    d: "M 185.5,183.5 C 189.309,184.105 192.643,184.105 195.5,183.5C 194.306,184.777 192.64,185.444 190.5,185.5C 188.36,185.444 186.694,184.777 185.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c1616",
    d: "M 242.5,178.5 C 242.181,183.363 242.514,188.03 243.5,192.5C 243.44,193.043 243.107,193.376 242.5,193.5C 241.186,188.348 241.186,183.348 242.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5b1313",
    d: "M 206.5,205.5 C 208.288,205.785 209.955,205.452 211.5,204.5C 210.388,203.735 209.721,202.735 209.5,201.5C 210.496,201.586 211.329,201.252 212,200.5C 212.495,202.473 212.662,204.473 212.5,206.5C 210.265,206.795 208.265,206.461 206.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 136.5,207.5 C 136.897,206.475 137.563,206.308 138.5,207C 140.329,208.113 141.163,209.613 141,211.5C 139.629,209.959 138.129,208.625 136.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a0d0c",
    d: "M 189.5,205.5 C 194.833,205.5 200.167,205.5 205.5,205.5C 205.5,206.167 205.5,206.833 205.5,207.5C 205.167,207.5 204.833,207.5 204.5,207.5C 200.833,207.5 197.167,207.5 193.5,207.5C 192.167,206.833 190.833,206.167 189.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 260.5,206.5 C 261.239,206.369 261.906,206.536 262.5,207C 261,208.5 259.5,210 258,211.5C 258.058,209.565 258.891,207.898 260.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e82f2f",
    d: "M 193.5,207.5 C 197.167,207.5 200.833,207.5 204.5,207.5C 204.334,213.842 204.5,220.175 205,226.5C 205.333,226.833 205.667,227.167 206,227.5C 206.497,225.19 206.663,222.857 206.5,220.5C 206.5,219.5 206.5,218.5 206.5,217.5C 207.167,223.5 207.833,229.5 208.5,235.5C 205.918,238.792 205.918,242.125 208.5,245.5C 208.5,246.167 208.5,246.833 208.5,247.5C 207.532,249.607 207.198,251.941 207.5,254.5C 206.732,255.263 206.232,256.263 206,257.5C 205.5,257 205,256.5 204.5,256C 200.833,255.667 197.167,255.333 193.5,255C 193.833,254.667 194.167,254.333 194.5,254C 193.877,251.393 193.21,248.893 192.5,246.5C 189.69,242.17 189.856,237.837 193,233.5C 193.5,224.84 193.666,216.173 193.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 153.5,216.5 C 153.897,215.475 154.563,215.308 155.5,216C 159.333,219.833 163.167,223.667 167,227.5C 167.667,228.167 167.667,228.833 167,229.5C 161.971,225.636 157.471,221.303 153.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 243.5,215.5 C 244.239,215.369 244.906,215.536 245.5,216C 241.667,221.167 237.167,225.667 232,229.5C 231.333,228.833 231.333,228.167 232,227.5C 236.037,223.631 239.87,219.631 243.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 120.5,217.5 C 120.897,216.475 121.563,216.308 122.5,217C 127,221.5 131.5,226 136,230.5C 136.667,231.167 136.667,231.833 136,232.5C 130.965,227.297 125.798,222.297 120.5,217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 276.5,216.5 C 277.239,216.369 277.906,216.536 278.5,217C 273.333,222.167 268.167,227.333 263,232.5C 262.333,231.833 262.333,231.167 263,230.5C 267.703,225.965 272.203,221.298 276.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f33131",
    d: "M 328.5,173.5 C 329.525,173.897 329.692,174.563 329,175.5C 300.833,203.667 272.667,231.833 244.5,260C 242.062,260.115 240.062,259.115 238.5,257C 240.163,256.735 241.663,257.235 243,258.5C 272.007,230.66 300.507,202.327 328.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a22121",
    d: "M 204.5,207.5 C 204.833,207.5 205.167,207.5 205.5,207.5C 205.182,212.032 205.515,216.366 206.5,220.5C 206.663,222.857 206.497,225.19 206,227.5C 205.667,227.167 205.333,226.833 205,226.5C 204.5,220.175 204.334,213.842 204.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d1919",
    d: "M 208.5,235.5 C 207.833,229.5 207.167,223.5 206.5,217.5C 206.523,215.073 207.023,212.74 208,210.5C 208.5,218.827 208.666,227.16 208.5,235.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#911f1e",
    d: "M 208.5,235.5 C 210.026,236.492 210.693,237.992 210.5,240C 210.607,242.221 209.94,244.054 208.5,245.5C 205.918,242.125 205.918,238.792 208.5,235.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 174.5,243.5 C 175.043,243.56 175.376,243.893 175.5,244.5C 170.474,247.359 166.641,251.359 164,256.5C 164.703,249.959 168.203,245.626 174.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f43231",
    d: "M 223.5,243.5 C 230.425,245.25 234.258,249.583 235,256.5C 231.964,251.307 228.131,246.974 223.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b62525",
    d: "M 192.5,246.5 C 193.21,248.893 193.877,251.393 194.5,254C 194.167,254.333 193.833,254.667 193.5,255C 197.167,255.333 200.833,255.667 204.5,256C 205,256.5 205.5,257 206,257.5C 206.232,256.263 206.732,255.263 207.5,254.5C 207.5,255.833 207.5,257.167 207.5,258.5C 202.368,258.392 197.202,258.725 192,259.5C 191.51,258.207 191.343,256.873 191.5,255.5C 192.299,252.57 192.632,249.57 192.5,246.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#480f10",
    d: "M 208.5,247.5 C 208.424,251.384 209.09,255.05 210.5,258.5C 209.833,259.833 208.833,260.833 207.5,261.5C 207.5,260.5 207.5,259.5 207.5,258.5C 207.5,257.167 207.5,255.833 207.5,254.5C 207.198,251.941 207.532,249.607 208.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f1d1d",
    d: "M 191.5,255.5 C 191.343,256.873 191.51,258.207 192,259.5C 197.202,258.725 202.368,258.392 207.5,258.5C 207.5,259.5 207.5,260.5 207.5,261.5C 207.5,262.167 207.167,262.5 206.5,262.5C 201.787,261.291 197.121,261.291 192.5,262.5C 191.5,262.167 190.833,261.5 190.5,260.5C 190.216,258.585 190.549,256.919 191.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#631414",
    d: "M 206.5,262.5 C 206.167,263.5 205.5,264.167 204.5,264.5C 200.901,263.656 197.234,263.323 193.5,263.5C 192.833,263.5 192.5,263.167 192.5,262.5C 197.121,261.291 201.787,261.291 206.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#330c0b",
    d: "M 193.5,263.5 C 197.234,263.323 200.901,263.656 204.5,264.5C 203.188,266.479 201.521,268.145 199.5,269.5C 197.146,267.812 195.146,265.812 193.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#801a1a",
    d: "M 204.5,296.5 C 200.901,297.344 197.234,297.677 193.5,297.5C 195.146,295.188 197.146,293.188 199.5,291.5C 201.521,292.855 203.188,294.521 204.5,296.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ad2323",
    d: "M 204.5,296.5 C 205.627,297.122 206.627,297.955 207.5,299C 205.391,300.907 202.891,301.74 200,301.5C 195.171,298.925 193.005,300.259 193.5,305.5C 194.5,305.5 195.5,305.5 196.5,305.5C 195.737,306.268 194.737,306.768 193.5,307C 195.058,307.21 196.391,307.71 197.5,308.5C 195.167,308.5 192.833,308.5 190.5,308.5C 190.5,314.833 190.5,321.167 190.5,327.5C 189.509,321.021 189.176,314.354 189.5,307.5C 190.5,307.5 191.5,307.5 192.5,307.5C 192.5,304.5 192.5,301.5 192.5,298.5C 192.5,297.833 192.833,297.5 193.5,297.5C 197.234,297.677 200.901,297.344 204.5,296.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#641616",
    d: "M 196.5,305.5 C 200.167,306.833 203.833,306.833 207.5,305.5C 206.737,306.268 205.737,306.768 204.5,307C 210.512,306.568 212.512,309.068 210.5,314.5C 209.504,314.586 208.671,314.252 208,313.5C 207.506,311.866 207.34,310.199 207.5,308.5C 204.167,308.5 200.833,308.5 197.5,308.5C 196.391,307.71 195.058,307.21 193.5,307C 194.737,306.768 195.737,306.268 196.5,305.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e42e2e",
    d: "M 197.5,308.5 C 200.833,308.5 204.167,308.5 207.5,308.5C 207.34,310.199 207.506,311.866 208,313.5C 208.671,314.252 209.504,314.586 210.5,314.5C 210.967,330.75 204.3,335.083 190.5,327.5C 190.5,321.167 190.5,314.833 190.5,308.5C 192.833,308.5 195.167,308.5 197.5,308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b0704",
    d: "M 199.5,321.5 C 202.275,321.834 202.941,323.167 201.5,325.5C 200.295,324.423 199.628,323.09 199.5,321.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUntitled1);
export default __webpack_public_path__ + "static/media/Untitled-1.9b9718b0f59216d36ff10a92b7b3654a.svg";
export { ForwardRef as ReactComponent };